import type { PendingPromptData } from '../../types';
import { Button } from '../../components/Button';
import { Markdown } from '../../components/Markdown';

// Il Piano di PopTown di «pianifichiamo insieme» (PIANO.md nello spazio di lavoro), con la barra
// per approvarlo quando la sessione aspetta proprio quella risposta.
export function PopTownPlanPanel({
  doc,
  pending,
  busy,
  onAnswer,
}: {
  doc: string;
  pending: PendingPromptData | null;
  busy: boolean;
  onAnswer: (choice: string) => void;
}) {
  const asking = pending?.about === 'poptown_plan' ? (pending.options ?? []) : [];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <article style={{ flex: 1, padding: '18px 20px 24px', maxWidth: 860 }}>
        <Markdown text={doc} />
      </article>
      {asking.length > 0 && (
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            borderTop: '1px solid var(--border)',
            background: 'var(--panel)',
            padding: '12px 20px',
            display: 'flex',
            gap: 10,
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <span className="t-caption dim" style={{ flex: 1, minWidth: 200 }}>
            Approvato, diventa il piano della sessione: il PM fa partire i lavori.
          </span>
          {[...asking].reverse().map((o) => (
            <Button
              key={o.label}
              variant={o.recommended ? 'primary' : 'secondary'}
              icon={o.recommended ? 'play' : undefined}
              loading={busy && o.recommended}
              disabled={busy}
              onClick={() => onAnswer(o.label)}
            >
              {o.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
